import styled from "styled-components";
export const FieldCont = styled.div`
  width: ${(p) => (p.inputWidth ? p.inputWidth : "100%")};
  height: ${(p) => (p.inputHeight ? p.inputHeight : "")};
  margin: ${(p) => (p.margin ? p.margin : "")};
  .labelCont {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  }
  .lblText {
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: ${(p) => (p.theme ? p.theme.colors.black.base : "#141823")};
  }
  .lblSubText {
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: #898b91;
    margin-left: 0.5rem;
  }
  .textInput {
    width: 100%;
    height: ${(p) => (p.inputHeight ? p.inputHeight : "3.5rem")};
    padding: ${(p) => (p.padding ? p.padding : "0.6rem 1rem")};
    border: 0.1rem #e5edf6 solid;
    border-radius: 0.4rem;
    font-size: 1.4rem;
    color: #141823;
    outline: 0;
  }
`;
